<template>
  <div>
    <div class="cbg-white-container input-container theme--light v-card border-card">
      <v-row class="m-0">
        <v-col cols="4" md="4" sm="6" class="col-12">
          <div class="common-search position-relative">
            <label for>Search by name / Referral code</label>
            <input
              class="form-control"
              label="Search by Name"
              placeholder="Name"
              v-model="search"
              @input="debounceSearch"
            />
            <div
              v-if="search !== ''"
              class="cross-svg center-cross-svg position-absolute"
              @click="clearSearch()"
            >
              <crossSVG />
            </div>
          </div>
        </v-col>
        <v-col cols="4" md="4" sm="6" class="col-12 datepicker pos-r">
          <label for>Date Range</label>
          <div>
            <datepicker
              v-model="date"
              @input="onDateChange()"
              ref="datepicker"
              :model-config="datePickerConfig"
              :max-date="new Date()"
              is-range
              :masks="{ input: 'DD/MM/YYYY' }"
            >
              <template v-slot="{ inputValue, inputEvents }">
                <input
                  :value="
                    !!inputValue.start && !!inputValue.end
                      ? inputValue.start + ' - ' + inputValue.end
                      : 'DD/MM/YYYY'
                  "
                  v-on="inputEvents.start"
                  class="form-control position-relative"
                  placeholder="DD/MM/YYYY"
                />
                <div
                  v-if="!!inputValue.start && !!inputValue.end"
                  class="cross-svg"
                  @click="resetActiveDate"
                >
                  <crossSVG />
                </div>
              </template>
            </datepicker>
            <div class="calendarsvg userinputcalendar pos-a">
              <calendarSVG />
            </div>
          </div>
        </v-col>
      </v-row>
      <!-- ................. -->
      <v-col cols="12" class="mt-2">
        <div class="table-div overflow-auto">
          <table class="table table-responsive userlistTable small-table-width">
            <thead>
              <tr class="table-success">
                <th scope="col">User Name</th>
                <th scope="col">Contact</th>
                <th scope="col">Ref code No.</th>
                <th scope="col">Points received</th>
                <th scope="col">Points used</th>
                <th scope="col">Balance</th>
                <th scope="col">Number of Referred Users</th>
                <th scope="col">Action</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="item in entries" :key="item.belongs_to">
                <td>
                  <div>{{ item.metadata && item.metadata.name || "-" }}</div>
                </td>
                <td>
                  <div>{{ item.metadata && item.metadata.contact || "-" }}</div>
                </td>
                <td>
                  <div>{{ item.metadata && item.metadata.code || "-" }}</div>
                </td>
                <td>
                  <div>{{ item.metadata && item.referal_added }}</div>
                </td>
                <td>
                  <div>{{ item.metadata && item.referal_used }}</div>
                </td>
                <td>
                  <div>{{ item.metadata && item.referal_balance }}</div>
                </td>
                <td>
                  <div>
                    {{
                    item.metadata && item.metadata.codeUsedCount
                    ? item.metadata.codeUsedCount
                    : "&#8213;"
                    }}
                  </div>
                </td>
                <td class="action-div small-table-padding">
                  <div>
                    <CDropdown color="link" size="lg" :caret="false" class="dropdowndocbox">
                      <template #toggler-content>
                        <verticalDotsSVG />
                      </template>
                      <CDropdownItem @click="showReferralsModal(item.belongs_to)">View Details</CDropdownItem>
                      <CDropdownItem @click="goToChat(item.belongs_to)">Message</CDropdownItem>
                    </CDropdown>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <CPagination
          class="pagination-block"
          align="end"
          :active-page.sync="page"
          :pages="Math.ceil(total / limit)"
          @update:activePage="onChangePage"
        />
      </v-col>
      <!-- ................. -->
      <referred-list-user-based-modal
        v-if="referredListDetails"
        :userId="selectedUserId"
        :referredListDetails="referredListDetails"
        @close="referredListDetails = false"
      ></referred-list-user-based-modal>
    </div>
  </div>
</template>
<script>
import debounce from "lodash/debounce";
import dayjs from "dayjs";
const Datepicker = () => import("v-calendar/lib/components/date-picker.umd");
const referredListUserBasedModal = () =>
  import("@/components/modals/referredListUserBasedModal");
import { pickSvg } from "@/views/SVG";
import config from "@/config.js";
const ACCOUNTS_API_URL = `${config.ACCOUNTS_URL}ds-accounts-be`;

export default {
  mounted() {
    this.searchEntries();
  },
  data() {
    return {
      referredListDetails: false,
      // filters
      search: "",
      startDate: "",
      endDate: "",
      date: { start: "", end: "" },
      // pagination
      limit: 10,
      offset: 0,
      page: 1,
      total: 0,
      // data
      entries: [],
      // ui
      loading: false,
      datePickerConfig: {
        start: {
          timeAdjust: "00:00:00"
        },
        end: {
          timeAdjust: "23:59:59"
        }
      },
      selectedUserId: ""
    };
  },
  components: {
    Datepicker,
    ...pickSvg("verticalDotsSVG", "crossSVG"),
    referredListUserBasedModal
  },
  methods: {
    resetActiveDate() {
      this.date = { start: "", end: "" };
      this.startDate = "";
      this.endDate = "";
      this.searchEntries();
    },
    clearSearch() {
      this.search = "";
    },
    debounceSearch: debounce(function() {
      this.searchEntries();
    }, 800),
    onChangePage(page) {
      this.offset = (page - 1) * this.limit;
      this.searchEntries();
    },
    onTypeChange(value) {
      this.type = value;
      this.searchEntries();
    },
    onLimitChange(e) {
      this.limit = parseInt(e.target.value, 10);
      this.searchEntries();
    },
    onDateChange(date) {
      this.startDate = dayjs(this.date.start).format("YYYY-MM-DD");
      this.endDate = dayjs(this.date.end)
        .add(1, "day")
        .format("YYYY-MM-DD");
      this.onChangePage(1);
    },
    onClearDate() {
      this.date = "";
      this.startDate = null;
      this.endDate = null;
      this.searchEntries();
    },
    getSearchParams() {
      const params = Object.assign(
        {},
        {
          limit: this.limit,
          offset: this.offset
        }
      );
      if (this.startDate && this.endDate) {
        params.start = this.startDate;
        params.end = this.endDate;
      }
      if (this.search.length > 0) {
        params.global = this.search;
      }
      return params;
    },
    searchEntries() {
      this.loading = true;
      this.entries = [];
      const params = this.getSearchParams();
      this.$http
        .get(`${ACCOUNTS_API_URL}/userCredit/search-referal`, {
          params
        })
        .then(
          response => {
            this.loading = false;
            this.total = Number(response.headers.get("query-count"));
            this.entries = response.data.data;
          },
          err => {
            this.loading = false;
            this.entries = [];
            console.log(err);
          }
        );
    },
    showReferralsModal(belongs_to) {
      this.selectedUserId = belongs_to;
      this.referredListDetails = true;
    },
    goToChat(userId) {
      this.$http
        .post(`${config.BASE_URL}api/v2/admin/system-chats`, {
          user_id: userId
        })
        .then(response => {
          if (response.body.status) {
            this.$router.push({
              name: "chat",
              params: {
                chatId: response.body.data._id
              }
            });
          }
        });
    }
  }
};
</script>